import { useState } from 'react'

// Campo de senha com o olho para conferir o que foi digitado.
//
// ⚠ Existe porque ela achou em 23/08/2026, usando a recuperacao de senha: eram
// 4 campos em 3 telas e nenhum deixava conferir. No celular, com teclado
// pequeno e senha que exige maiuscula e simbolo, errar sem enxergar e a regra.
//
// Um componente so, e nao o olho copiado em tres telas -- mesma decisao do
// CampoNomeDeTabela. A guarda em campoSenha.contrato.test.ts impede que alguem
// volte a escrever <input type="password"> na mao.

type Props = {
  /** Vira o `id` do campo e o `htmlFor` do rotulo. ⚠ E por este vinculo que os
   *  testes de ponta a ponta acham a senha com getByLabel. */
  id: string
  rotulo: string
  valor: string
  aoMudar: (valor: string) => void
  autoComplete: string
  minLength?: number
}

export default function CampoSenha({
  id,
  rotulo,
  valor,
  aoMudar,
  autoComplete,
  minLength,
}: Props) {
  // Nasce escondido, sempre, e nao guarda memoria entre telas: ninguem quer a
  // propria senha aparecendo por padrao dentro do onibus.
  const [mostrando, setMostrando] = useState(false)

  return (
    <div>
      <label htmlFor={id} className="block text-sm text-slate-600 mb-1">
        {rotulo}
      </label>
      <div className="relative">
        <input
          id={id}
          type={mostrando ? 'text' : 'password'}
          required
          minLength={minLength}
          autoComplete={autoComplete}
          value={valor}
          onChange={(e) => aoMudar(e.target.value)}
          // pr-12 abre espaco para o botao nao cobrir o que esta escrito.
          className="w-full border border-slate-300 rounded-lg px-3 py-2 pr-12"
        />
        <button
          // ⚠ type="button" e obrigatorio: dentro de um <form>, botao sem tipo
          // e botao de ENVIAR -- tocar no olho tentaria entrar no app.
          type="button"
          onClick={() => setMostrando((antes) => !antes)}
          // ⚠ O nome NAO pode conter a palavra "senha": os 97 E2E entram no app com
          // getByLabel('Senha'), que casa por PEDACO de texto -- um botao chamado
          // "Mostrar senha" respondia pela mesma busca e o login parava de
          // funcionar em todos eles. Medido: o teste acusou 2 elementos.
          // O nome muda com o estado: e o que o leitor de tela anuncia e o que
          // o teste procura. Botao so com desenho dentro nao tem nome nenhum.
          aria-label={mostrando ? 'Ocultar o texto digitado' : 'Mostrar o texto digitado'}
          aria-pressed={mostrando}
          className="absolute right-0 top-0 h-full px-3 flex items-center text-slate-500"
        >
          {mostrando ? <OlhoFechado /> : <OlhoAberto />}
        </button>
      </div>
    </div>
  )
}

/** Desenhado aqui em vez de vir de biblioteca: sao dois icones, e o pacote que
 *  vai para o celular ja e grande. */
function OlhoAberto() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  )
}

function OlhoFechado() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  )
}
